import { GET_TRANSACTIONS, LOADING, SAVE_SEARCH_PARAM, SAVE_PAGINATION_DATA } from '../types';

const initialState = {
    transactions: [],
    loading: false,
    paginationData: {},
    searchParam: {
        pageSize: 20,
        pageNo: 1,
        transactionReference: '',
        status: '',
        startDate: '',
        endDate: '',
        customerEmail: ''
    }
}


export default function (state = initialState, action) {
    switch (action.type) {
        case GET_TRANSACTIONS:
            return {
                ...state,
                transactions: action.payload,
                loading: false
            }
        case SAVE_SEARCH_PARAM:
            return {
                ...state,
                searchParam: action.payload
            }
        case SAVE_PAGINATION_DATA:
            return {
                ...state,
                paginationData: action.payload
            }
        case LOADING:
            return {
                ...state,
                loading: action.payload
            }
        default:
            return state
    }
}
